import { EWalletId } from '@ankr.com/provider';
import { isMobile } from 'web3modal';

import { WalletButton } from './WalletButton';

const DOWNLOAD_BINANCE_URL =
  'https://chrome.google.com/webstore/detail/binance-wallet/fhbohimaelbohpjbbldcngcnapndodjp';
const BINANCE_WALLET_ID = EWalletId.binanceWallet;

interface Props {
  loading?: boolean;
  onConnect: (walletId: EWalletId) => void;
}

export function BinanceWallet({
  loading,
  onConnect,
}: Props): JSX.Element | null {
  const injected = !!window.BinanceChain;

  if (isMobile()) {
    return null;
  }

  return (
    <WalletButton
      walletId={BINANCE_WALLET_ID}
      disabled={loading}
      onClick={() => onConnect(BINANCE_WALLET_ID)}
      installLink={injected ? '' : DOWNLOAD_BINANCE_URL}
    />
  );
}
